import i18n from 'modules/core/lib/i18n'

import employeeStatuses, { type EmployeeStatus } from './hooks/utils/employeeStatuses'

export interface EmployeeStatusOption {
  value: EmployeeStatus
  label: string
}

export const employeeStatusOptions = async (): Promise<EmployeeStatusOption[]> => {
  const options = [
    {
      value: employeeStatuses.active,
      label: i18n.t('employees.active'),
    },
    {
      value: employeeStatuses.terminated,
      label: i18n.t('employees.terminated'),
    },
    {
      value: employeeStatuses.withWelcomeSpaceAccess,
      label: i18n.t('employees.with_welcome_space_access'),
    },
    {
      value: employeeStatuses.away,
      label: i18n.t('employees.away'),
    },
    {
      value: employeeStatuses.awayThisMonth,
      label: i18n.t('employees.away_this_month'),
    },
    {
      value: employeeStatuses.reportingToMe,
      label: i18n.t('employees.reporting_to_me'),
    },
    {
      value: employeeStatuses.reportingToMeDirectly,
      label: i18n.t('employees.reporting_to_me_directly'),
    },
    {
      value: employeeStatuses.timeoffManagedByMe,
      label: i18n.t('employees.timeoff_managed_by_me'),
    },
    {
      value: employeeStatuses.locationIssues,
      label: i18n.t('employees.location_issues'),
    },
    {
      value: employeeStatuses.clockIn,
      label: i18n.t('filters.filter.clocked_in'),
    },
    {
      value: employeeStatuses.onBreak,
      label: i18n.t('filters.filter.on_break'),
    },
  ]

  return options
}
